import { useEffect } from 'react';

// /privacy теперь редиректит на официальную политику ООО «ЛИЛИАНИ».
// Внутренний черновик снят; ссылки в футере/согласиях ведут туда же напрямую.
const POLICY_URL = 'https://liliani.ru/policy/';

export const PrivacyView = () => {
  useEffect(() => {
    window.location.replace(POLICY_URL);
  }, []);

  return (
    <div className="container py-16 text-center text-[15px] text-[#555]">
      Перенаправляем на{' '}
      <a href={POLICY_URL} className="text-[#007E3C] underline">
        политику обработки персональных данных
      </a>
      …
    </div>
  );
};
